import ViewGuard from './ViewGuard.component';

export default ViewGuard;